import { SectionHeading } from "./SectionHeading";

export const AboutSection = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="01"
                    kicker="About"
                    title="A builder somewhere between backend, infra, and weird ideas."
                />

                <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
                    <div className="md:col-span-7">
                        <div className="space-y-6 text-[var(--ink-text-secondary)]">
                            <p className="text-base leading-relaxed md:text-lg">
                                I’m a software engineer and student from{" "}
                                <span className="text-[var(--ink-text-primary)]">
                                    Kerala, India
                                </span>
                                , with a strong interest in backend engineering,
                                infrastructure, cloud systems, AI tooling, and
                                product design.
                            </p>
                            <p className="text-base leading-relaxed md:text-lg">
                                My work usually starts with a question:{" "}
                                <span className="text-[var(--ink-text-primary)]">
                                    “Can this be made simpler, smarter, or more
                                    useful?”
                                </span>{" "}
                                From there, I end up building APIs, dashboards,
                                automation tools, mobile apps, documentation
                                systems, hackathon prototypes, and sometimes
                                strange storytelling experiments about
                                technology.
                            </p>
                            <p className="text-base leading-relaxed md:text-lg">
                                I enjoy working close to the metal of software —
                                Kubernetes, cloud services, observability,
                                backend systems, databases, and developer
                                workflows. But I also care about product
                                experience: how a tool feels, how someone
                                understands it, and whether it actually solves
                                the problem.
                            </p>
                        </div>
                    </div>

                    <div className="md:col-span-5">
                        <div className="rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 md:p-8">
                            <div className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                                — file: about.yml
                            </div>
                            <dl className="space-y-4 font-mono text-sm">
                                <div className="flex items-start justify-between gap-6">
                                    <dt className="text-[var(--ink-text-secondary)]">
                                        role
                                    </dt>
                                    <dd className="text-right text-[var(--ink-text-primary)]">
                                        software engineer
                                    </dd>
                                </div>
                                <div className="flex items-start justify-between gap-6">
                                    <dt className="text-[var(--ink-text-secondary)]">
                                        student
                                    </dt>
                                    <dd className="text-right text-[var(--ink-text-primary)]">
                                        always
                                    </dd>
                                </div>
                                <div className="flex items-start justify-between gap-6">
                                    <dt className="text-[var(--ink-text-secondary)]">
                                        favourite_problem
                                    </dt>
                                    <dd className="text-right text-[var(--ink-text-primary)]">
                                        messy real-world systems
                                    </dd>
                                </div>
                                <div className="flex items-start justify-between gap-6">
                                    <dt className="text-[var(--ink-text-secondary)]">
                                        debug_method
                                    </dt>
                                    <dd className="text-right text-[var(--ink-text-primary)]">
                                        read · log · reproduce
                                    </dd>
                                </div>
                                <div className="flex items-start justify-between gap-6">
                                    <dt className="text-[var(--ink-text-secondary)]">
                                        currently
                                    </dt>
                                    <dd className="text-right text-ink-cyan">
                                        experimenting
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
